import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Recipes from "@/pages/Recipes";
import Inventory from "@/pages/Inventory";
import Sales from "@/pages/Sales";
import Purchases from "@/pages/Purchases";
import Reconciliation from "@/pages/Reconciliation";
import Settings from "@/pages/Settings";
import Login from "@/pages/Login";
import ContasAPagar from "@/pages/ContasAPagar";
import POS from "@/pages/POS";
import { AuthProvider } from "@/auth/AuthContext";
import ProtectedRoute from "@/auth/ProtectedRoute";

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#0F1B2D",
            border: "1px solid #E5E1D8",
            fontFamily: "DM Sans, sans-serif",
            borderRadius: 12,
          },
        }}
      />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="/conciliacao" element={<Reconciliation />} />
              <Route path="/fichas" element={<Recipes />} />
              <Route path="/estoque" element={<Inventory />} />
              <Route path="/compras" element={<Purchases />} />
              <Route path="/vendas" element={<Sales />} />
              <Route path="/pos" element={<POS />} />
              <Route path="/contas-a-pagar" element={<ContasAPagar />} />
              <Route path="/configuracoes" element={<Settings />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
